import { ADMIN_BASE_PATH } from "./adminNavConfig";

/** URL slug per service — used in `/users/:userId/:serviceSlug` */
export const USER_SERVICE_SLUGS = {
    profile: "profile",
    personalWhatsapp: "personal-whatsapp",
    email: "email",
    whatsappBusiness: "whatsapp-business",
};

export const USER_SERVICES = [
    {
        id: "profile",
        slug: USER_SERVICE_SLUGS.profile,
        label: "Account & Profile",
        shortLabel: "Profile",
        description: "Name, email, password, roles, account status, API key & bot version",
        accent: "#111827",
        subscriptionKey: null,
        configFlag: null,
        statusKey: null,
        isAccount: true,
    },
    {
        id: "personal_whatsapp",
        slug: USER_SERVICE_SLUGS.personalWhatsapp,
        label: "Personal WhatsApp",
        shortLabel: "Personal WA",
        description: "PWC credits, subscription & script health",
        accent: "#1d4ed8",
        subscriptionKey: "personal_whatsapp",
        configFlag: "personal_whatsapp",
        statusKey: "personal_whatsapp",
        requiredRole: "PERSONAL",
    },
    {
        id: "email",
        slug: USER_SERVICE_SLUGS.email,
        label: "Business Email",
        shortLabel: "Email",
        description: "BEC credits, AWS SES domains, senders, and worker config",
        accent: "#6d28d9",
        subscriptionKey: "email",
        configFlag: "email",
        statusKey: "email",
        requiredRole: "EMAIL",
    },
    {
        id: "whatsapp_business",
        slug: USER_SERVICE_SLUGS.whatsappBusiness,
        label: "WhatsApp Business",
        shortLabel: "WhatsApp Business",
        description: "WB API config, BWC credits, subscription & automation",
        accent: "#047857",
        subscriptionKey: "whatsapp_business",
        configFlag: "whatsapp_business",
        statusKey: "whatsapp_business",
        requiredRole: "WB-ADMIN",
    },
    {
        id: "credit_billing",
        slug: "billing",
        label: "Credit billing",
        shortLabel: "Billing",
        description: "Billing type, wallet balance, manual top-up and debit",
        accent: "#b45309",
        subscriptionKey: null,
        configFlag: null,
        statusKey: null,
        isAccount: true,
    },
];

export const getUserServicePath = (userId, serviceSlug) =>
    `${ADMIN_BASE_PATH}/users/${userId}/${serviceSlug}`;

export const openUserServiceInNewTab = (userId, serviceSlug) => {
    const url = getUserServicePath(userId, serviceSlug);
    window.open(url, "_blank", "noopener,noreferrer");
};

export const findServiceBySlug = (slug) =>
    USER_SERVICES.find((s) => s.slug === slug);
